export enum MarkerTypeTooltipIcon {
  WARN = 'mu-map-icon-warn',
  INFO = 'mu-map-icon-info',
}
